import Prom from '@leverege/promise';
import { DEFAULT_CONSTRAINTS } from '../Constants.js';

/**
 * @async
 * @function decodeFromImg wrapper for the zxing library decode from image method. It takes a qr code, bar code or data matrix and returns a decoded 
 * @param {*} source - an img HTMLElement, a File, or a data uri string that contains a code to be decoded
 * @returns {object} returns the decoded text of the code along with other metadata information about the code. 
 * @returns {Array} if source is a fil 
 */
async function decodeFromImg(source, options = {}) {
  const {
    zxOpts
  } = options;
  return import('@zxing/browser').then(({
    BrowserMultiFormatReader
  }) => {
    const reader = new BrowserMultiFormatReader(zxOpts);
    if (source instanceof HTMLElement && source.nodeName === 'IMG') {
      return reader.decodeFromImageElement(source);
    }
    if (source instanceof File) {
      return reader.decodeFromImageUrl(URL.createObjectURL(source));
    }
    if (source instanceof FileList) {
      return Prom.map(Array.from(source), async file => {
        try {
          const result = await decodeFromImg(file, options);
          return result;
        } catch (ex) {
          return ex;
        }
      });
    }
    if (Array.isArray(source)) {
      return Prom.map(source, async imgData => {
        try {
          const result = await decodeFromImg(imgData, options);
          return result;
        } catch (ex) {
          return ex;
        }
      });
    }

    // zxing doesn't seem to be able to handle https and http links due to a cross origin error when atempting to get a uri from a data canvas
    if (typeof source === 'string' && source.startsWith('data:image')) {
      return reader.decodeFromImageUrl(source);
    }
    return Promise.reject(new Error('Invalid code input source'));
  });
}
async function decodeFromConstraints(previewElem, constraints = {
  video: DEFAULT_CONSTRAINTS
}, options = {}) {
  const {
    onChange,
    onError,
    zxOpts,
    scanMilliseconds
  } = options;
  return import('@zxing/browser').then(({
    BrowserMultiFormatReader
  }) => {
    const reader = new BrowserMultiFormatReader(zxOpts, {
      delayBetweenScanAttempts: scanMilliseconds
    });
    return reader.decodeFromConstraints(constraints, previewElem, (result, error) => {
      if (result && typeof onChange === 'function') {
        onChange(result);
      }
      if (error && typeof onError === 'function') {
        onError(error);
      }
    });
  });
}
export { decodeFromImg, decodeFromConstraints };